import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">

        <div className="footer-top">

          {/* Left: Logo + tagline */}
          <div className="footer-brand">
            <img src="/assets/brand/logo.png" alt="Shortflix" className="footer-logo" />
            <p className="footer-brand-sub">Premium OTT Movies &amp; Series · Exclusive Shorts</p>
            <p className="footer-tagline">
              India's finest short films, web series &amp; exclusive OTT originals — bold stories, real emotions, always free to explore.
            </p>
          </div>

          {/* Center: Nav columns */}
          <div className="footer-links">
            <div className="footer-links-col">
              <span className="footer-col-title">Browse</span>
              <Link to="/">Home</Link>
              <Link to="/movies">Movies</Link>
              <Link to="/series">Series</Link>
              <a href="https://blog.shortflixindia.com" target="_blank" rel="noopener noreferrer">Blog</a>
              <button
                className="footer-search-btn"
                onClick={() => window.dispatchEvent(new CustomEvent('sf:open-search'))}
              >Search</button>
            </div>
            <div className="footer-links-col">
              <span className="footer-col-title">Account</span>
              <Link to="/profile">My Profile</Link>
              <Link to="/subscription">Subscribe</Link>
              <Link to="/profile?tv=1">Activate TV</Link>
              <a href="https://gateway.shortflixindia.com" target="_blank" rel="noopener noreferrer">Submit Film</a>
              <Link to="/mylist">My List</Link>
            </div>
            <div className="footer-links-col">
              <span className="footer-col-title">Know More</span>
              <Link to="/about">About</Link>
              <Link to="/faq">FAQ</Link>
              <Link to="/contact">Contact Us</Link>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms &amp; Conditions</Link>
            </div>
          </div>

          {/* Right: Platform Downloads */}
          <div className="footer-platforms">
            <p className="footer-platforms-label">
              <span className="footer-label-star">✦</span>
              Best Experienced On Your Screens
            </p>

            {/* Mobile */}
            <div className="footer-platform-group">
              <div className="footer-platform-header">
                <span className="footer-platform-icon">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                    <line x1="12" y1="18" x2="12.01" y2="18"/>
                  </svg>
                </span>
                <span className="footer-platform-name">Mobile</span>
              </div>
              <div className="footer-badges-row">
                <a href="https://play.google.com/store/apps/details?id=com.shortflix&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="app-badge-link">
                  <img src="/assets/store-badges/playstore.png" alt="Get it on Google Play" className="app-badge-img" />
                </a>
                <a href="https://apps.apple.com/in/app/shortflix/id1448385291" target="_blank" rel="noopener noreferrer" className="app-badge-link">
                  <img src="/assets/store-badges/appstore.png" alt="Download on the App Store" className="app-badge-img" />
                </a>
              </div>
            </div>

            {/* TV */}
            <div className="footer-platform-group">
              <div className="footer-platform-header">
                <span className="footer-platform-icon">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                    <line x1="8" y1="21" x2="16" y2="21"/>
                    <line x1="12" y1="17" x2="12" y2="21"/>
                  </svg>
                </span>
                <span className="footer-platform-name">Smart TV</span>
              </div>
              <div className="footer-tv-logos">
                <a href="#" className="footer-tv-logo-link" title="Amazon Fire TV">
                  <img src="/assets/tv-platforms/firetv.png" alt="Fire TV" className="footer-tv-logo" />
                </a>
                <a href="#" className="footer-tv-logo-link" title="Samsung Smart TV">
                  <img src="/assets/tv-platforms/samsungtv.png" alt="Samsung TV" className="footer-tv-logo" />
                </a>
                <a href="#" className="footer-tv-logo-link" title="LG webOS">
                  <img src="/assets/tv-platforms/lgweb.png" alt="LG webOS" className="footer-tv-logo" />
                </a>
                <a href="#" className="footer-tv-logo-link" title="JioTV">
                  <img src="/assets/tv-platforms/jiotv.png" alt="JioTV" className="footer-tv-logo" />
                </a>
                <a href="#" className="footer-tv-logo-link" title="Apple TV">
                  <img src="/assets/tv-platforms/appletv.png" alt="Apple TV" className="footer-tv-logo" />
                </a>
                <a href="#" className="footer-tv-logo-link" title="Android TV">
                  <img src="/assets/tv-platforms/androidtv.png" alt="Android TV" className="footer-tv-logo" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-divider" />

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} ShortFlix. Powered by Vaibhav Visuals India Private Limited.</p>
          <div className="footer-social">
            <a href="https://facebook.com/shortflixindia" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="footer-social-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            </a>
            <a href="https://instagram.com/shortflixindia" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="footer-social-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
            </a>
            <a href="https://twitter.com/shortflixindia" target="_blank" rel="noopener noreferrer" aria-label="Twitter / X" className="footer-social-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </a>
            <a href="https://youtube.com/@ShortFlix" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="footer-social-link">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="white"/></svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
